// semeia-disable-reexport
export function range(start: number): Array<number>;
export function range(start: number, stop: number): Array<number>;
export function range(start, stop?, step?): Array<number> {
  if (stop == null) {
    stop = start || 0;
    start = 0;
  }
  if (!step) {
    step = stop < start ? -1 : 1;
  }

  const length = Math.max(Math.ceil((stop - start) / step), 0);
  const range = Array(length);

  for (let idx = 0; idx <= length; idx++, start += step) {
    range[idx] = start;
  }

  return range;
}

export function arrayEquals(
  array1: Array<string>,
  array2: Array<string>
): boolean {
  const array1Sorted = array1.slice().toSorted();
  const array2Sorted = array2.slice().toSorted();

  return (
    array1Sorted.length == array2Sorted.length &&
    array1Sorted.every((value, index) => value === array2Sorted[index])
  );
}
